import { render, staticRenderFns } from "./GroupSubsection.vue?vue&type=template&id=6c65e8b8&scoped=true"
import script from "./GroupSubsection.vue?vue&type=script&lang=js"
export * from "./GroupSubsection.vue?vue&type=script&lang=js"
import style0 from "./GroupSubsection.vue?vue&type=style&index=0&id=6c65e8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c65e8b8",
  null
  
)

export default component.exports